var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-tooltip',{ref:"ellip",staticClass:"ellipShow",attrs:{"popper-class":"tooltip-v3","disabled":_vm.disabled,"content":_vm.input,"placement":"top"}},[_vm._t("content"),_vm._t("default",function(){return [_c('span',{domProps:{"textContent":_vm._s(_vm.input)}})]}),_vm._t("suffix")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }